import {ValueObject} from '@s-ui/domain'

import {VehiclesMappersFactory} from '../Mappers/factory.js'

export class ModelDetailContentV2ValueObject extends ValueObject {
  #body
  #cons
  #description
  #faqs
  #photos
  #pros
  #rating
  #seoFaqs
  #title

  constructor({body, cons, description, faqs, photos, pros, rating, title, seoFaqs}) {
    super()
    this.#body = body
    this.#cons = cons
    this.#description = description
    this.#faqs = faqs
    this.#photos = photos
    this.#pros = pros
    this.#rating = rating
    this.#title = title
    this.#seoFaqs = seoFaqs
  }

  get body() {
    return this.#body
  }

  get cons() {
    return this.#cons
  }

  get description() {
    return this.#description
  }

  get faqs() {
    return this.#faqs
  }

  get photos() {
    return this.#photos
  }

  get pros() {
    return this.#pros
  }

  get rating() {
    return this.#rating
  }

  get title() {
    return this.#title
  }

  get seoFaqs() {
    return this.#seoFaqs
  }

  static createFromPrimitive({body, cons, description, faqs, photos, pros, rating, title, seoFaqs}) {
    return new ModelDetailContentV2ValueObject({body, cons, description, faqs, photos, pros, rating, title, seoFaqs})
  }

  static createFromContentfulData({config, contentfulData}) {
    const contentDataMapper =
      VehiclesMappersFactory.fromModelDetailContentfulRawDataToModelDetailContentValueObjectMapper({
        config
      })
    const {body, cons, description, faqs, photos, pros, title, seoFaqs} = contentDataMapper
      .map({data: contentfulData})
      .toJSON()
    return ModelDetailContentV2ValueObject.createFromPrimitive({
      body,
      cons,
      description,
      faqs,
      photos,
      pros,
      title,
      seoFaqs
    })
  }

  get value() {
    return {
      body: this.#body,
      cons: this.#cons,
      description: this.#description,
      faqs: this.#faqs,
      photos: this.#photos,
      pros: this.#pros,
      rating: this.#rating,
      title: this.#title,
      seoFaqs: this.#seoFaqs
    }
  }
}
